import { $themeBreakpoints } from '@themeConfig';

export default {
  namespaced: true,

  state: {
    // baseURL: 'https://api.showattack.tmss-repo.com/storage/app/public/images/',
    // profileURL: 'https://api.showattack.tmss-repo.com/storage/app/public/profile/',
    // fileURL: 'https://api.showattack.tmss-repo.com/storage/app/public/files/',
    // settingURL: 'https://api.showattack.tmss-repo.com/storage/app/public/settings/',

    // pdfFileURL: 'https://api.showattack.tmss-repo.com/storage/app/public/pdf/pdf/',

    // https://api.showattack.tmss-repo.com/api/storage/app/public/pdf/pdf/Week_1.pdf
    //app/public/files/iZ8Da0MfQGAkdep6NpxxmrClrCIolUGxicusRxQI.pdf

    baseURL: 'https://api.showattack.systemstailormade.com/storage/images/',
    profileURL: 'https://api.showattack.systemstailormade.com/storage/profile/',
    fileURL: 'https://api.showattack.systemstailormade.com/storage/files/',
    settingURL: 'https://api.showattack.systemstailormade.com/storage/settings/',

    pdfFileURL: 'https://api.showattack.systemstailormade.com/storage/pdf/pdf/',

    windowWidth: 0,
    shallShowOverlay: false,
    token: '',
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state;
      if (windowWidth >= $themeBreakpoints.xl) return 'xl';
      if (windowWidth >= $themeBreakpoints.lg) return 'lg';
      if (windowWidth >= $themeBreakpoints.md) return 'md';
      if (windowWidth >= $themeBreakpoints.sm) return 'sm';
      return 'xs';
    },

    isAuthenticated(state) {
      return state.token !== '';
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val;
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay;
    },
  },
  actions: {},
};
